import { render, staticRenderFns } from "./SemesterAdminTable.vue?vue&type=template&id=a075dc06"
import script from "./SemesterAdminTable.vue?vue&type=script&lang=js"
export * from "./SemesterAdminTable.vue?vue&type=script&lang=js"
import style0 from "./SemesterAdminTable.vue?vue&type=style&index=0&id=a075dc06&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports